import styled, { css } from 'styled-components';
import { borderRadius, compose, height, width } from 'styled-system';
import { borderRadiusAttrs } from '../utils/attrs/borderRadiusAttrs';
import { applyVariations, getPaletteColor } from '../utils/utils';
const variations = {
  parallax: css(["background-attachment:fixed;"]),
  static: css(["background-attachment:scroll;"])
};
/**
 * @public
 */
export const backgroundPositionList = ['top', 'bottom', 'left', 'right', 'center'];
const image = props => props.image ? {
  backgroundImage: `url(${props.image})`
} : null;
/**
 * @public
 */
export const BackgroundImage = /*#__PURE__*/styled.div.attrs(borderRadiusAttrs).withConfig({
  displayName: "BackgroundImage",
  componentId: "sc-1eaij4d-0"
})(["background-position:", ";background-size:cover;background-repeat:no-repeat;background-color:", ";", " ", "  ", ""], props => props.backgroundPosition, getPaletteColor('border.light'), applyVariations('BackgroundImage', variations), image, props => compose(height, width, borderRadius)(props));
BackgroundImage.defaultProps = {
  variation: 'static',
  backgroundPosition: 'center'
};
BackgroundImage.displayName = 'BackgroundImage';